export class commentM{
    CLIENT_ID: number;
    USER_ID: number;
    ID: number;
    TYPE: number;
    TYPE_ID: number;
    COMMENT_TEXT: string;
    COMMENT_DATETIME: any;
    TAGGED_USERS: any;
    IS_ACTIVE: boolean;
}